<template>
  <nav :class="{'bg-transparent text-black': !isDarkMode, 'bg-white text-black': isDarkMode}" class="absolute top-0 left-0 w-full z-10">
    <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
      <a href="/" class="flex items-center space-x-3">
        <img src="/images/logo.svg" class="h-12" alt="logo" />
      </a>

      <!-- Przycisk menu mobilnego -->
      <button @click="toggleMenu" class="md:hidden p-2" :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}">
        <svg class="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"/>
        </svg>
      </button>

      <!-- Menu nawigacyjne dla desktopu -->
      <div class="hidden w-full md:block md:w-auto">
        <ul class="flex space-x-2">
          <li v-for="(item, index) in menuItems" :key="index">
            <router-link
                v-if="!item.link.includes('#')"
                :to="item.link"
                class="nav-link relative block transition-all duration-300 ease-in-out font-bold"
                :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}">
              {{ item.name }}
            </router-link>

            <a v-else
               :href="item.link"
               class="nav-link relative block cursor-pointer transition-all duration-300 ease-in-out font-bold"
               :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}"
               @click.prevent="scrollToSection(item.link)">
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Menu mobilne -->
    <div v-if="isMenuOpen" class="fixed inset-0 bg-[#002A4A] bg-opacity-95 flex flex-col items-center justify-center space-y-6" :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}">
      <button @click="toggleMenu" class="absolute top-6 right-6 text-2xl" :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}">
        ✕
      </button>
      <ul class="flex flex-col space-y-6 text-xl">
        <li v-for="(item, index) in menuItems" :key="index">
          <router-link
              v-if="!item.link.includes('#')"
              :to="item.link"
              class="nav-link block text-center transition-all duration-300 ease-in-out"
              :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}"
              @click="toggleMenu">
            {{ item.name }}
          </router-link>

          <a v-else
             :href="item.link"
             class="nav-link block text-center transition-all duration-300 ease-in-out"
             :class="{'text-black': isDarkMode, 'text-white': !isDarkMode}"
             @click.prevent="scrollToSection(item.link)">
            {{ item.name }}
          </a>
        </li>
      </ul>
    </div>

    <!-- Linia oddzielająca menu -->
    <div :class="{'bg-white': !isDarkMode, 'bg-black': isDarkMode}" class="w-full h-[1px]"></div>
  </nav>
</template>

<script>
export default {
  props: {
    darkMode: Boolean
  },
  data() {
    return {
      isMenuOpen: false,
      menuItems: [
        { name: "Strona główna", link: "/" },
        { name: "Galeria Zdjęć", link: "/galeria" },
        { name: "O nas", link: "/#about" },
        { name: "Kontakt", link: "/kontakt" }
      ],
    };
  },
  computed: {
    isDarkMode() {
      return this.darkMode;
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : 'auto';
    },
    scrollToSection(link) {
      const hash = link.split('#')[1];
      const scroll = () => {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      };

      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          setTimeout(scroll, 300);
        });
      } else {
        scroll();
      }

      // Zawsze zamknij menu mobilne po kliknięciu:
      this.isMenuOpen = false;
      document.body.style.overflow = 'auto';
    }
  }
};
</script>


<style scoped>
.nav-link {
  position: relative;
  padding: 8px 12px;
}

.nav-link:hover {
  color: #E9A53D;
}

.nav-link::before,
.nav-link::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border: 2px solid #E9A53D;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.nav-link::before {
  top: 0;
  left: 0;
  border-right: none;
  border-bottom: none;
}

.nav-link::after {
  bottom: 0;
  right: 0;
  border-left: none;
  border-top: none;
}

.nav-link:hover::before,
.nav-link:hover::after {
  opacity: 1;
}

@media (max-width: 768px) {
  .nav-link {
    font-size: 24px;
    padding: 12px 16px;
  }
}
</style>
